import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PiiDisplay from "../../components/PiiReportDisplay/PiiReport";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import { useAuth } from "context/AuthContext";

const PIIReport = () => {
  const { hasAnyPermission } = useAuth();

  const { classRosterId } = useParams();

  useEffect(() => {
    applicationUsageLog(
      localStorage.getItem("User"),
      localStorage.getItem("EmailId"),
      "ASTT",
      "PII Report",
    );
  }, []);

  const [PIIReportDisplay, setPIIReportDisplay] = useState(false);

  useEffect(() => {
    if (
      hasAnyPermission([
        "PII_Group",
        "PII_Group_Low",
        "PII_Group_Med",
        "PII_Group_FULL",
      ])
    ) {
      setPIIReportDisplay(true);
    }
  }, [hasAnyPermission]);

  return (
    <div>
      <>
        {PIIReportDisplay ? (
          <PiiDisplay rosterId={classRosterId} />
        ) : (
          <>Not eligible to access this page.</>
        )}
      </>
    </div>
  );
};

export default PIIReport;
